import React from 'react';
import { BaseProductCard } from './BaseProductCard';

interface ProductCardProps {
  productId: string;
  cardIndex?: number;
  cardCount?: number;
}

export const ProductCard = ({
  productId,
  cardIndex,
  cardCount,
}: ProductCardProps) => {
  return (
    <BaseProductCard
      productId={productId}
      cardIndex={cardIndex}
      cardCount={cardCount}
    />
  );
};
